import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { usePost } from "seed/api";
import { useQuery } from "seed/gql";
import { Loading } from "seed/helpers";
import { useUserUsage } from "components/util/helpers/UserUsage";
import l from "components/util/l";
import View from "components/presentation/forms/flows/FlowCreateForm.view";

function FlowFormCreate({ match, onSave }) {

  const userId = sessionStorage.getItem("id");
  const isDeveloper = sessionStorage.getItem("is_developer") == "true";
  const [selectedTemplateFlow, setSelectedTemplateFlow] = useState(null);
  const historyRouter = useHistory();

  const [callSave] = usePost("/flows/create_flow", {
    onCompleted: (createdFlow) => {
      if (onSave != null) return onSave(createdFlow);
      window.location.replace("/")
    }, onError: (error) => {
      if (error.status == 400)
        return swal(l("Has llegado a tu límite de soluciones%VG104"), l("Actualiza tu plan%VG105"), "error");
      swal(l("Error al crear solución%SB001"), l("Por favor cierra sesión y vuelve a entrar%SB035"), "error")
    }
  });

  const onClickDevButton = () => {
    callSave({
      name: "Nuevo proceso",
      description: "",
      settings: {},
      owner_id: userId,
    });
  }

  // const userId = sessionStorage.getItem("id");
  // const isDeveloper = sessionStorage.getItem("is_developer") == "true";
  // const historyRouter = useHistory();
  // const { userUsage } = useUserUsage();

  // const { folderId = null } = match?.params ?? {};
  // const initialValues = {
  //   folder: folderId,
  //   owner: parseInt(userId),
  //   show_animations: true,
  //   show_pagination: false
  // }

  // const [callSave, reqSave] = usePost("/flows/create_flow_from_template", {
  //   onCompleted: (createdFlow) => {
  //     if (onSave != null) return onSave(createdFlow);
  //     historyRouter.replace(`/${createdFlow.token}`)
  //   }, onError: (error) => {
  //     if (error.status == 400)
  //       return swal(l("Has llegado a tu límite de soluciones%VG104"),
  //         l("Actualiza tu plan%VG105"), "error");
  //     swal(l("Error al crear solución%SB001"), l("Por favor cierra sesión y vuelve a entrar%SB035"), "error")
  //   }
  // });

  // const reqFlows = useQuery(`{
  //     flows {
  //       id
  //       name
  //     }
  //   }`, `user.id = ${userId} AND is_active=true AND is_current_version=true`, { orderBy: "name" });

  // const reqFolders = useQuery(`{
  //   folders {
  //     name
  //   }
  // }`, `user.id = ${userId}`, { orderBy: "name" });

  // const reqTemplateCategories = useQuery(`{
  //   templateCategories {
  //     name
  //     description
  //     uiSettings
  //   }
  // }`, "", { orderBy: "name" });


  // useEffect(() => {
  //     reqFlows.refetch();
  //     reqFolders.refetch();
  //   }, []);


  // const onSubmit = (values) => {
  //   const newValues = {
  //     name: values.name ?? "",
  //     description: values.description ?? "",
  //     settings: {},
  //     owner_id: values.owner,
  //     parent_id: values.parent_id,
  //   }

  //   if (values.folder != "0")
  //     newValues.folder_id = parseInt(values.folder);

  //   if (isDeveloper) {
  //     newValues.is_template = values?.is_template ?? false;
  //     newValues.template_name = values?.template_name ?? values?.name ?? "";
  //     newValues.template_settings = values?.template_settings ?? {};
  //     newValues.template_categories = values?.template_categories ?? [];
  //     newValues.template_type = values?.template_type ?? "USE_CASE";
  //   }
  //   callSave(newValues);
  // }

  // if (reqFolders.loading || reqTemplateCategories.loading) return <Loading />;
  // if (reqFolders.error || reqTemplateCategories.error) return "Error";

  // const { flows = [] } = reqFlows.data;
  // const { folders = [] } = reqFolders.data;
  // const { templateCategories = [] } = reqTemplateCategories.data;

  const onSelectFlowTemplate = (templateId) => {
    setSelectedTemplateFlow(templateId);
  }

  const onSubmit = () => {
    if (!selectedTemplateFlow) {
      swal(l("Selecciona una plantilla%SB036"), "", "warning");
      return;
    }

  }

  return (
    <View
      // userUsage={userUsage}
      // flows={flows}
      // folders={folders}
      // initialValues={initialValues}
      // templateCategories={templateCategories}
      // isDeveloper={isDeveloper}
      // historyRouter={historyRouter}
      // onSubmit={onSubmit}
      isDeveloper={isDeveloper}
      selectedTemplateFlow={selectedTemplateFlow}
      onSelectFlowTemplate={onSelectFlowTemplate}
      onClickDevButton={onClickDevButton}
      onSubmit={onSubmit}
    />
  );
}

export default FlowFormCreate;